import { Component, Input, Output, EventEmitter } from '@angular/core';
import { EventFilterOption } from 'src/app/models/core/event.model';
import { trigger, transition, style, animate, state } from '@angular/animations';

@Component({
  selector: 'app-filter-tabs',
  templateUrl: './filter-tabs.component.html',
  styleUrls: ['./filter-tabs.component.scss'],
  standalone: false
})
export class FilterTabsComponent {

  @Input() options: EventFilterOption[] = [];
  @Input() selected: string = '';
  @Output() filterChange = new EventEmitter<string>();

  @Input() context: 'modal' | 'main' = 'modal';

  select(option: string) {
    this.filterChange.emit(option);
  }

  getSelectedIndex(): number {
    const index = this.options.findIndex(option => option.value === this.selected);
    return index >= 0 ? index : 0;
  }

}
